import React from "react";
import { LegalPage } from "@/components/LegalPage";

export const FairHousingPage: React.FC = () => (
  <LegalPage
    title="Fair Housing Statement"
    lastUpdated="September 16, 2026"
    intro="Feingold Property Management, LLC is committed to providing equal professional service to all clients and prospective residents without regard to race, color, religion, sex, national origin, familial status, disability, or any other status protected by applicable federal, state, or local law."
    sections={[
      {
        heading: "Our Commitment",
        body: (
          <p>
            We adhere to the Fair Housing Act and all applicable
            anti-discrimination laws. We do not discriminate in the rental,
            lease, or management of any property based on a protected
            characteristic. Every prospective resident is evaluated on
            objective, consistent criteria.
          </p>
        ),
      },
      {
        heading: "Equal Opportunity in Marketing",
        body: (
          <p>
            Our marketing and advertising is designed to reach a broad and
            inclusive audience. We do not use language, imagery, or targeting
            that indicates any preference, limitation, or discrimination based
            on a protected class.
          </p>
        ),
      },
      {
        heading: "Consistent Screening Standards",
        body: (
          <p>
            Tenant screening is applied uniformly to all applicants using
            objective criteria such as credit history, income verification,
            rental references, and background checks as permitted by law. All
            applicants receive the same standards of evaluation.
          </p>
        ),
      },
      {
        heading: "Accessibility",
        body: (
          <p>
            We strive to ensure our services and properties are accessible.
            Reasonable accommodations and modifications for persons with
            disabilities are provided as required by law and upon request.
          </p>
        ),
      },
      {
        heading: "Reporting Concerns",
        body: (
          <p>
            If you believe you have experienced discrimination or have a fair
            housing concern related to our services, please contact us promptly.
            We take all such reports seriously and will investigate and respond
            appropriately.
          </p>
        ),
      },
      {
        heading: "Equal Housing Opportunity",
        body: (
          <p>
            This property is managed in accordance with Fair Housing laws. We
            support the Equal Housing Opportunity principle that all persons
            have the right to seek housing without discrimination.
          </p>
        ),
      },
    ]}
  />
);
